import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00200-input-form q-gutter-y-md" }
const _hoisted_2 = { class: "row q-mb-sm" }
const _hoisted_3 = { class: "column stock-price-file-name" }
const _hoisted_4 = { class: "q-ml-sm" }
const _hoisted_5 = { class: "column file-size q-pl-sm" }
const _hoisted_6 = { class: "q-ml-sm" }
const _hoisted_7 = { class: "row q-gutter-x-sm q-mb-lg" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col-1.5 cmd00200-template-button" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "q-gutter-sm" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "q-gutter-sm" }
const _hoisted_15 = {
  class: "col",
  style: {"margin-top":"2px"}
}
const _hoisted_16 = { class: "col q-mt-sm q-mb-lg" }
const _hoisted_17 = { class: "col q-mt-sm q-mb-sm price-input" }
const _hoisted_18 = { class: "col q-mt-sm price-input" }
const _hoisted_19 = { class: "col q-mt-sm" }
const _hoisted_20 = { class: "q-gutter-sm" }
const _hoisted_21 = { class: "col q-mt-md" }
const _hoisted_22 = { class: "col q-mt-sm" }
const _hoisted_23 = { class: "q-gutter-sm flex" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "row q-gutter-x-sm q-ml-sm" }
const _hoisted_26 = { class: "row items-center justify-end" }
const _hoisted_27 = { class: "row items-center justify-end" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col q-gutter-x-xs flex justify-end" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import {
  isEmpty,
  isNumeric,
  isTwoDecimalPlaces,
  isDecimalDigits,
} from '../../common/utils/validateUtils';

import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import SupplierSelects from '../../components/selects/SupplierSelects.vue';
import CategorySelects from '../../components/selects/CategorySelects.vue';
import FormatItemSelects from '../../components/selects/FormatItemSelects.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import messages from '../../messages/message.json';

interface Props {
  // CSVファイル名
  fileName: string;
}

// 在庫価格項目名プルダウン
interface FormatItemOption {
  label: string;
  value: string;
}

// 在庫価格項目名
interface StockPriceItemName {
  number: number;
  system_item_name: string;
  system_item_key: string;
  format_item_value: string;
  error: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00200',
  props: {
    fileName: {}
  },
  setup(__props: any) {

const router = useRouter();
const props = __props;

// 在庫価格ファイル名
const fileName = ref('');
// ファイルサイズ
const fileSize = ref('');

// サプライヤ名
const supplier = ref('');
// カテゴリー
const category = ref('');

// 文字コード
const characterCode = ref('1');
// ヘッダ行の有無
const headerLine = ref('0');
// 過去データ
const pastData = ref('1');

// 価格単位
const priceUnit = ref('USD');
// 割引率
const discountRate = ref('0.00');
// 手数料
const commission = ref('0.00');

// 価格単位プルダウン
const priceOptions = ref<FormatItemOption[]>([
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'JPY',
    value: 'JPY',
  },
]);

// 「テンプレートとして登録する」フラグ
const addTempleteFlag = ref(false);

// 備考
const memo = ref('');

// 処理スケジュールタイプ(0:処理日時指定 1:即時実行)
const scheduleType = ref('1');
// スケジュール日付
const scheduleDate = ref('');
// スケジュール日付(リセット用)
const resetScheduleDate = ref('');
// スケジュール時間
const scheduleTime = ref('');
// スケジュール時間(リセット用)
const resetScheduleTime = ref('');

// 在庫価格ファイル項目名プルダウン
const formatItemOptions = ref<FormatItemOption[]>([]);

// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);
// テンプレートDialog表示フラグ
const isTemplateDialogFlg = ref(false);
// 登録Dialog表示フラグ
const isRegisterDialogFlg = ref(false);
// CSV文字コードエラーDialog表示フラグ
const isFileFormatDialogFlg = ref(false);

// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);

// 項目名設定カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const colums: Array<any> = [
  {
    name: 'number',
    label: '番号',
    align: 'left',
    field: (row: StockPriceItemName) => row.number,
    classes: 'text-right',
  },
  {
    name: 'system_item_name',
    label: 'システム取込項目名',
    align: 'left',
    field: 'system_item_name',
  },
  {
    name: 'format_item_name',
    label: '在庫価格ファイル項目名',
    align: 'left',
    field: 'format_item_name',
    headerClasses: 'stock-price-file-name',
  },
];

// 項目名設定テーブルデータ
const rows = ref<StockPriceItemName[]>([
  {
    number: 1,
    system_item_name: 'サプライヤ商品コード',
    system_item_key: 'id_number',
    format_item_value: '',
    error: false,
  },
  {
    number: 2,
    system_item_name: '化学名',
    system_item_key: 'name',
    format_item_value: '',
    error: false,
  },
  {
    number: 3,
    system_item_name: '在庫状況',
    system_item_key: 'stock_status',
    format_item_value: '',
    error: false,
  },
  {
    number: 4,
    system_item_name: '容量',
    system_item_key: 'capacity',
    format_item_value: '',
    error: false,
  },
  {
    number: 5,
    system_item_name: '荷姿',
    system_item_key: 'packing',
    format_item_value: '',
    error: false,
  },
  {
    number: 6,
    system_item_name: '仕入価格',
    system_item_key: 'purchase_price',
    format_item_value: '',
    error: false,
  },
  {
    number: 7,
    system_item_name: '納期',
    system_item_key: 'delivery_date',
    format_item_value: '',
    error: false,
  },
  {
    number: 8,
    system_item_name: '備考',
    system_item_key: 'remarks',
    format_item_value: '',
    error: false,
  },
  {
    number: 9,
    system_item_name: '保管温度',
    system_item_key: 'storage_temperature',
    format_item_value: '',
    error: false,
  },
  {
    number: 10,
    system_item_name: '純度',
    system_item_key: 'purity',
    format_item_value: '',
    error: false,
  },
  {
    number: 11,
    system_item_name: 'MDL',
    system_item_key: 'mdl',
    format_item_value: '',
    error: false,
  },
  {
    number: 12,
    system_item_name: 'CAS No.',
    system_item_key: 'cas',
    format_item_value: '',
    error: false,
  },
  {
    number: 13,
    system_item_name: 'URL',
    system_item_key: 'url',
    format_item_value: '',
    error: false,
  },
]);

/**
 * データクリア
 */
const clearData = () => {
  headerLine.value = '0';
  characterCode.value = '0';
  pastData.value = '1';
  supplier.value = '';
  category.value = '';
  memo.value = '';
  addTempleteFlag.value = false;
  priceUnit.value = 'USD';
  discountRate.value = '0.00';
  commission.value = '0.00';
  scheduleType.value = '1';
  scheduleDate.value = resetScheduleDate.value;
  scheduleTime.value = resetScheduleTime.value;
  errMessage.value = '';
  isMessageChip.value = false;
  // 在庫価格ファイル項目名プルダウンのクリア
  rows.value.forEach((value, index) => {
    rows.value[index].format_item_value = '';
    rows.value[index].error = false;
  });
};

/**
 * 在庫価格ファイル取込(CSV)画面に戻る
 */
const backPage = () => {
  router.push({ name: 'stockPrice' });
};

/**
 * 登録確認ダイアログ表示
 */
const displayRegisterDialog = () => {
  dialogTitle.value = 'スケジュール登録確認';
  dialogLevel.value = 'information';
  dialogText.value = [`入力した内容で取込スケジュールを登録します。`, 'よろしいですか？'];
  isConfFlg.value = false;
  isRegisterDialogFlg.value = true;
};

/**
 * 登録完了ダイアログ
 */
const completeRegisterDialog = () => {
  dialogTitle.value = 'スケジュール登録完了';
  dialogLevel.value = 'information';
  dialogText.value = ['スケジュールの登録が完了しました。'];
  isConfFlg.value = true;
  isRegisterDialogFlg.value = true;
};

/**
 * エラーメッセージ表示
 */
const displayErrMsg = () => {
  errMessage.value = messages.ja.message.MSG_50070E;
  isMessageChip.value = true;
  // TOPにスクロール
  setTimeout(() => window.scrollTo({ top: 0 }), 400);
};

/**
 * 初期表示データ取得
 */
const getInitData = () => {
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('file_name', props.fileName);

  axios
    .post('/cmd002001/init', formData)
    .then((res) => {
      const { common, csvInfo, currentDate, currentTime } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 各項目に設定
          fileName.value = csvInfo.file_name;
          fileSize.value = csvInfo.file_size;
          scheduleDate.value = currentDate;
          resetScheduleDate.value = currentDate;
          scheduleTime.value = currentTime;
          resetScheduleTime.value = currentTime;
          // 在庫価格ファイル項目名プルダウンを設定
          Object.keys(csvInfo.csv_name_list).forEach((key) => {
            let label;
            // 35文字以上の場合は省略
            if (csvInfo.csv_name_list[key].length > 35) {
              label = `${csvInfo.csv_name_list[key].substr(0, 35)}...`;
            } else {
              label = csvInfo.csv_name_list[key];
            }
            formatItemOptions.value.push({
              label,
              value: key,
            });
          });
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // ファイル形式エラーの場合
            case DetailResultStatusCode.FILE_FORMAT_ERROR:
              // エラーダイアログ表示
              dialogTitle.value = 'ファイル読み込みエラー';
              dialogLevel.value = 'error';
              dialogText.value = [
                'CSVファイルの内容に誤りがあります。',
                '内容を確認して、再度CSVファイルをアップロードしてください。',
              ];
              isConfFlg.value = true;
              isFileFormatDialogFlg.value = true;
              break;

            // ファイルが存在しない場合
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              dialogTitle.value = 'ファイル読み込みエラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isFileFormatDialogFlg.value = true;
              break;

            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * テンプレート読み込み
 */
const readTemplete = () => {
  // Loading Start
  Loading.show();
  // エラーリセット
  errMessage.value = '';
  isMessageChip.value = false;
  // 在庫価格ファイル項目名プルダウンのクリア
  rows.value.forEach((value, index) => {
    rows.value[index].format_item_value = '';
    rows.value[index].error = false;
  });
  const formData = new FormData();
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value);

  axios
    .post('/cmd002001/read-template', formData)
    .then((res) => {
      const { common, template } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // テンプレート設定
          characterCode.value = String(template.character_code);
          headerLine.value = String(template.header);
          Object.entries(template).forEach(([key, value]) => {
            rows.value.forEach((item, index) => {
              // システム取込項目名と在庫価格CSVテンプレートの項目名が一致した場合
              if (item.system_item_key === key) {
                formatItemOptions.value.forEach((v) => {
                  if (v.value === String(value)) {
                    // 在庫価格ファイル項目名プルダウンを設定
                    rows.value[index].format_item_value = String(value);
                  }
                });
              }
            });
          });
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // テンプレートが未登録の場合
            case DetailResultStatusCode.TEMPLATE_NOT_EXIST_ERROR:
              // 「テンプレートを登録する」をチェック状態にする
              addTempleteFlag.value = true;
              // 警告ダイアログ表示
              dialogTitle.value = 'テンプレート未登録';
              dialogLevel.value = 'warning';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isTemplateDialogFlg.value = true;
              break;

            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 在庫価格CSV登録
 */
const registerStockPriceCsv = () => {
  // Loading Start
  Loading.show();
  // エラーリセット
  errMessage.value = '';
  isMessageChip.value = false;
  isRegisterDialogFlg.value = false;
  rows.value.forEach((value, index) => {
    rows.value[index].error = false;
  });

  // 登録データ設定
  const formData = new FormData();
  formData.append('file_name', fileName.value);
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value);
  formData.append('character_code', characterCode.value);
  formData.append('header_line', headerLine.value);
  // 価格設定
  formData.append('price_unit', priceUnit.value);
  formData.append('discount_rate', discountRate.value);
  if (priceUnit.value === 'JPY') {
    formData.append('commission', `${commission.value}.00`);
  } else {
    commission.value = Number(commission.value).toFixed(2);
    formData.append('commission', commission.value);
  }
  // その他設定
  formData.append('past_data', pastData.value);
  formData.append('memo', memo.value);
  // 取込予定日時
  formData.append('schedule_type', scheduleType.value);
  formData.append('schedule_date', scheduleDate.value);
  formData.append('schedule_time', scheduleTime.value);
  // 項目名設定
  rows.value.forEach((value) => {
    if (value.format_item_value) {
      formData.append(`stock_price_file_map[${value.system_item_key}]`, value.format_item_value);
    } else {
      // プルダウンが選択されていない場合は0を設定
      formData.append(`stock_price_file_map[${value.system_item_key}]`, '0');
    }
  });
  formData.append('add_templete_flag', addTempleteFlag.value ? '1' : '0');

  axios
    .post('/cmd002001/register-csv-file', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 完了ダイアログ表示
          completeRegisterDialog();
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // サプライヤ商品コードが選択されていない場合
            case DetailResultStatusCode.IDNUMBER_NOT_EXIST_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              rows.value.forEach((value, index) => {
                if (value.system_item_key === 'id_number') {
                  rows.value[index].error = true;
                }
              });
              break;
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      // TOPにスクロール
      setTimeout(() => window.scrollTo({ top: 0 }), 400);
    });
};

/**
 * 初期表示処理
 */
// propsが存在しない場合
if (!props.fileName) {
  // 前画面に遷移
  backPage();
} else {
  // 初期表示データ取得
  getInitData();
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_form = _resolveComponent("q-form")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[26] || (_cache[26] = [
        _createTextVNode("在庫価格ファイル取込フォーマット指定")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      greedy: "",
      onSubmit: displayRegisterDialog,
      onReset: clearData,
      onValidationError: displayErrMsg
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[27] || (_cache[27] = _createElementVNode("label", null, "在庫価格ファイル名 ", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(fileName.value), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[28] || (_cache[28] = _createElementVNode("label", null, "ファイルサイズ", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(fileSize.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "requier" }, "サプライヤ名", -1)),
              _createVNode(SupplierSelects, {
                supplier: supplier.value,
                "is-validate": true,
                onSelectSupplier: _cache[0] || (_cache[0] = ($event: any) => (supplier.value = $event))
              }, null, 8, ["supplier"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "requier" }, "カテゴリー", -1)),
              _createVNode(CategorySelects, {
                category: category.value,
                "is-validate": true,
                onSelectCategory: _cache[1] || (_cache[1] = ($event: any) => (category.value = $event))
              }, null, 8, ["category"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_q_btn, {
                color: "primary",
                style: {"width":"200px","height":"42px"},
                class: _normalizeClass(supplier.value && category.value ? '' : 'cmd00200-disabled-btn'),
                label: "テンプレートを読み込む",
                disable: supplier.value && category.value ? false : true,
                onClick: readTemplete
              }, null, 8, ["class", "disable"]),
              (supplier.value && category.value ? false : true)
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 0,
                    anchor: "top middle",
                    self: "bottom middle",
                    offset: [1, 1]
                  }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createElementVNode("strong", null, "サプライヤ名とカテゴリーを選択してください", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[32] || (_cache[32] = _createElementVNode("label", { class: "requier" }, "文字コード", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_q_radio, {
                modelValue: characterCode.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((characterCode).value = $event)),
                val: "1",
                label: "UTF-8"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_q_radio, {
                modelValue: characterCode.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((characterCode).value = $event)),
                val: "0",
                label: "Shift-JIS"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[33] || (_cache[33] = _createElementVNode("label", { class: "requier" }, "ヘッダ行の有無", -1)),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_q_radio, {
                modelValue: headerLine.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((headerLine).value = $event)),
                val: "0",
                label: "有"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_q_radio, {
                modelValue: headerLine.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((headerLine).value = $event)),
                val: "1",
                label: "無"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col" }, [
            _createElementVNode("label", {
              class: "text-weight-bold",
              style: {"font-size":"1.1rem"}
            }, "項目名設定")
          ], -1)),
          _createElementVNode("div", {
            class: _normalizeClass(
            'cmd00200-item-table chem-table-area ' + (rows.value.length === 0 ? 'table-nodata' : '')
          )
          }, [
            _createVNode(_component_q_table, {
              rows: rows.value,
              columns: colums,
              "row-key": "number",
              flat: "",
              separator: "cell",
              "hide-pagination": "",
              "rows-per-page-options": [rows.value.length]
            }, {
              body: _withCtx((cell) => [
                _createVNode(_component_q_tr, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_td, {
                      key: "number",
                      class: "text-right",
                      style: {"width":"1.5rem"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cell.row.number), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_td, { key: "system_item_name" }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", {
                          class: _normalizeClass(cell.row.number === 1 && 'requier')
                        }, _toDisplayString(cell.row.system_item_name), 3)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_td, { style: {"min-width":"280px"} }, {
                      default: _withCtx(() => [
                        _createVNode(FormatItemSelects, {
                          number: cell.row.number,
                          value: cell.row.format_item_value,
                          error: cell.row.error,
                          options: formatItemOptions.value,
                          onSelectItem: ($event: any) => (cell.row.format_item_value = $event)
                        }, null, 8, ["number", "value", "error", "options", "onSelectItem"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["rows", "rows-per-page-options"]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_q_checkbox, {
                modelValue: addTempleteFlag.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addTempleteFlag).value = $event))
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("テンプレートとして登録する")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 2),
          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("label", {
              class: "text-weight-bold",
              style: {"font-size":"1.1rem"}
            }, "価格設定")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { class: "requier" }, "価格単位", -1)),
            _createVNode(_component_q_select, {
              modelValue: priceUnit.value,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((priceUnit).value = $event)),
                _cache[8] || (_cache[8] = ($event: any) => (priceUnit.value === 'JPY' ? (commission.value = '0') : (commission.value = '0.00')))
              ],
              options: priceOptions.value,
              outlined: "",
              dense: "",
              "emit-value": "",
              "map-options": "",
              style: {"background":"var(--q-white)","padding":"0","width":"30%"},
              rules: [(val) => !!val || _ctx.$t('validation.required')]
            }, null, 8, ["modelValue", "options", "rules"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "requier" }, "割引率", -1)),
            _createVNode(_component_q_input, {
              modelValue: discountRate.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((discountRate).value = $event)),
              outlined: "",
              dense: "",
              rules: [
              (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
              (val) =>
                !(val < 0.0 || val > 1.0) ||
                _ctx.$t('validation.between', { param1: '0.00', param2: '1.00' }),
            ],
              "lazy-rules": "",
              hint: "0.00～1.00で入力してください",
              mask: "#.##",
              style: {"width":"30%"},
              "input-class": "text-right",
              "reverse-fill-mask": "",
              maxlength: "4",
              onKeydown: _cache[10] || (_cache[10] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
              onKeypress: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { class: "requier" }, "手数料", -1)),
            _createVNode(_component_q_input, {
              modelValue: commission.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((commission).value = $event)),
              outlined: "",
              dense: "",
              rules: 
              priceUnit.value === 'JPY'
                ? [
                    (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                    (val) => _unref(isNumeric)(val) || _ctx.$t('validation.integer_only'),
                  ]
                : [
                    (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                    (val) => _unref(isDecimalDigits)(val) || _ctx.$t('validation.numeric_only'),
                    (val) => _unref(isTwoDecimalPlaces)(val) || _ctx.$t('validation.two_decimal_places'),
                    (val) =>
                      parseInt(val, 10) < 100000000 ||
                      _ctx.$t('validation.max_integer', { param1: '8' }),
                  ]
            ,
              "lazy-rules": "",
              suffix: priceOptions.value.find((data) => data.value === priceUnit.value)?.label,
              style: {"width":"30%"},
              "input-class": "text-right",
              maxlength: priceUnit.value === 'JPY' ? 8 : 11,
              onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules", "suffix", "maxlength"])
          ]),
          _cache[44] || (_cache[44] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("label", {
              class: "text-weight-bold",
              style: {"font-size":"1.1rem"}
            }, "その他設定")
          ], -1)),
          _createElementVNode("div", _hoisted_19, [
            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "requier" }, "過去データ", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_q_radio, {
                modelValue: pastData.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((pastData).value = $event)),
                val: "1",
                label: "削除する"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_q_radio, {
                modelValue: pastData.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((pastData).value = $event)),
                val: "0",
                label: "削除しない"
              }, null, 8, ["modelValue"])
            ]),
            _cache[39] || (_cache[39] = _createElementVNode("div", null, [
              _createElementVNode("p", { class: "q-mb-none" }, " ※「削除する」を選択した場合、選択したサプライヤとカテゴリーに紐づく過去に取り込んだすべての在庫価格が削除されます。 ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[40] || (_cache[40] = _createElementVNode("label", null, "備考", -1)),
            _createVNode(_component_q_input, {
              modelValue: memo.value,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((memo).value = $event)),
              outlined: "",
              dense: "",
              type: "textarea",
              rows: "2",
              "bg-color": "white",
              counter: "",
              maxlength: "200"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "requier" }, "取込予定日時", -1)),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_q_radio, {
                modelValue: scheduleType.value,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((scheduleType).value = $event)),
                val: "1",
                label: "即時実行"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_q_radio, {
                  modelValue: scheduleType.value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((scheduleType).value = $event)),
                  val: "0",
                  label: "処理日時指定",
                  class: "q-mr-sm"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_q_input, {
                    modelValue: scheduleDate.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((scheduleDate).value = $event)),
                    outlined: "",
                    dense: "",
                    disable: scheduleType.value == '1',
                    class: "date q-pb-none",
                    readonly: "",
                    style: {"background":"var(--q-white)","width":"140px"},
                    clearable: ""
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "event",
                        class: "cursor-pointer"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_q_popup_proxy, {
                        cover: "",
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_date, {
                            modelValue: scheduleDate.value,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((scheduleDate).value = $event)),
                            minimal: "",
                            "no-unset": "",
                            mask: "YYYY/MM/DD"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_26, [
                                _withDirectives(_createVNode(_component_q_btn, {
                                  label: "OK",
                                  color: "primary",
                                  flat: ""
                                }, null, 512), [
                                  [_directive_close_popup]
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disable"]),
                  _createVNode(_component_q_input, {
                    modelValue: scheduleTime.value,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((scheduleTime).value = $event)),
                    outlined: "",
                    disable: scheduleType.value == '1',
                    dense: "",
                    class: "date q-pb-none",
                    readonly: "",
                    style: {"background":"var(--q-white)","width":"126px"},
                    clearable: ""
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "access_time",
                        class: "cursor-pointer"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_q_popup_proxy, {
                        cover: "",
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_time, {
                            modelValue: scheduleTime.value,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((scheduleTime).value = $event)),
                            mask: "HH:mm",
                            format24h: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_27, [
                                _withDirectives(_createVNode(_component_q_btn, {
                                  label: "OK",
                                  color: "primary",
                                  flat: ""
                                }, null, 512), [
                                  [_directive_close_popup]
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disable"])
                ])
              ])
            ])
          ]),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_q_btn, {
                  color: "grey-7",
                  outline: "",
                  label: "戻る",
                  style: {"min-width":"120px","background":"var(--q-white) !important"},
                  onClick: backPage
                }),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    color: "primary",
                    style: {"width":"150px"},
                    label: "登録"
                  }),
                  _createVNode(_component_q_btn, {
                    type: "reset",
                    outline: "",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: "mdi-eraser",
                    label: "クリア"
                  })
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isFileFormatDialogFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: backPage,
      onClose: backPage
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isTemplateDialogFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[23] || (_cache[23] = ($event: any) => (isTemplateDialogFlg.value = false)),
      onClose: _cache[24] || (_cache[24] = ($event: any) => (isTemplateDialogFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isRegisterDialogFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: backPage,
      onConfirm: registerStockPriceCsv,
      onClose: _cache[25] || (_cache[25] = ($event: any) => (isRegisterDialogFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})